import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { EnquiriesService } from './../../services/enquiries.service';
import { FormGroup, FormBuilder, Validators, FormControl, FormArray } from '@angular/forms';
import { ToastService } from './../../services/toast.service';
import { NULL_EXPR } from '@angular/compiler/src/output/output_ast';


declare var $: any;

@Component({
  selector: 'app-bsa-enquiry',
  templateUrl: './bsa-enquiry.component.html',
})
export class BsaEnquiryComponent implements OnInit {

  scrollTimer: any;

  EnquiryData_BsaForm$: FormGroup;
  ResultMessage_BsaForm$: string = "";
  submitted_bsa: boolean = false;
  pageErrors_BsaForm: boolean = false;
  captchaInvalid_BsaForm: boolean = true;



  public show:boolean = false;
  public ShowLinkedIn:boolean = false;
  public ShowTwitter:boolean = false;
  public ShowInstagram:boolean = false;
  public ShowFacebook:boolean = false;
  public ShowYoutube:boolean = false;
  public DvShowLinkedIn:boolean = false;
 



  public buttonName:any = 'Show';
  public InputName:string = "";

  constructor(   
    private datePipe: DatePipe, 
    private enquiriesService: EnquiriesService,
    private formBuilder: FormBuilder,
    public toastService: ToastService) 
    {

    }

  resolvedbsaform(captchaResponse: string) {
    if (captchaResponse === null) {
      this.captchaInvalid_BsaForm = true;
    }
    else {
      this.captchaInvalid_BsaForm = false;
    }
  }

  get f_bsaform() { return this.EnquiryData_BsaForm$.controls; }
  
  sendBSAEnquiry()
  {
  
   this.ResultMessage_BsaForm$ = "Submitting, please wait...";

    this.submitted_bsa = true;
    this.pageErrors_BsaForm = false;

    if (this.EnquiryData_BsaForm$.invalid) {
      this.pageErrors_BsaForm = true;
      console.log(this.ShowLinkedIn);
      this.ResultMessage_BsaForm$ = 'One or more fields are invalid.';
      return;
    }

    if (this.captchaInvalid_BsaForm == true) {
      this.pageErrors_BsaForm = true;
      this.ResultMessage_BsaForm$ = "Please complete the captcha";
      return;
    }
    var currentDate = new Date(this.datePipe.transform(new Date(), 'yyyy-MM-ddTHH:mm:ss.SSS'));

    let enquiry = {
      "id": 0,
      "sectionId": 7,
      "dateAdded": currentDate,
      "enquiryProperties": []
    };

  
    enquiry.enquiryProperties.push({ "key": "nameAndSurname", "value": this.EnquiryData_BsaForm$.controls.bsaNameSurname.value });
    enquiry.enquiryProperties.push({ "key": "bsacontactNumber", "value": this.EnquiryData_BsaForm$.controls.bsacontactNumber.value });
    enquiry.enquiryProperties.push({ "key": "emailAddress", "value": this.EnquiryData_BsaForm$.controls.bsaemailAddress.value });
    enquiry.enquiryProperties.push({ "key": "bsacompanyName", "value": this.EnquiryData_BsaForm$.controls.bsacompanyName.value });
    enquiry.enquiryProperties.push({ "key": "bsaofficeNumber", "value": this.EnquiryData_BsaForm$.controls.bsaofficeNumber.value });
    enquiry.enquiryProperties.push({ "key": "bsawebsite", "value": this.EnquiryData_BsaForm$.controls.bsawebsite.value });
    enquiry.enquiryProperties.push({ "key": "message", "value": this.EnquiryData_BsaForm$.controls.bsamessage.value });
    
    //enquiry.enquiryProperties.push({ "key": "isLinkedIn", "value": this.EnquiryData_BsaForm$.controls.isLinkedIn.value });
    enquiry.enquiryProperties.push({ "key": "bsalinkedin", "value": this.EnquiryData_BsaForm$.controls.bsalinkedin.value });

    // enquiry.enquiryProperties.push({ "key": "isTwitter", "value": this.EnquiryData_BsaForm$.controls.isTwitter.value });
     enquiry.enquiryProperties.push({ "key": "bsatwitter", "value": this.EnquiryData_BsaForm$.controls.bsatwitter.value });

    //enquiry.enquiryProperties.push({ "key": "isFacebook", "value": this.EnquiryData_BsaForm$.controls.isFacebook.value });
    enquiry.enquiryProperties.push({ "key": "bsafacebook", "value": this.EnquiryData_BsaForm$.controls.bsafacebook.value });

    // enquiry.enquiryProperties.push({ "key": "isInstagram", "value": this.EnquiryData_BsaForm$.controls.isInstagram.value });
    enquiry.enquiryProperties.push({ "key": "bsainstagram", "value": this.EnquiryData_BsaForm$.controls.bsainstagram.value });

    // enquiry.enquiryProperties.push({ "key": "isYoutube", "value": this.EnquiryData_BsaForm$.controls.isYoutube.value });
    enquiry.enquiryProperties.push({ "key": "bsayoutube", "value": this.EnquiryData_BsaForm$.controls.bsayoutube.value });
    enquiry.enquiryProperties.push({ "key": "topicId", "value": "101" });
    enquiry.enquiryProperties.push({ "key": "topic", "value": "BSA Enquiry" });


    this.enquiriesService.saveEnquiry(enquiry).subscribe((response) => {


      this.ResultMessage_BsaForm$ = "Your message has been sent!";

      this.toastService.show('BSA ENQUIRY - Your message was successfully sent.', { classname: 'bg-success text-light', delay: 7500, autohide: true });
      this.EnquiryData_BsaForm$.reset();
      

      Object.keys(this.EnquiryData_BsaForm$.controls).forEach(key => {
        this.EnquiryData_BsaForm$.get(key).setErrors(null);
      });


      this.EnquiryData_BsaForm$.controls.recaptchaReactive = null;

    }, (error) => {
      this.pageErrors_BsaForm = false;
        this.ResultMessage_BsaForm$ = "An error occurred. Please try again later.";
        this.toastService.show('BSA ENQUIRY - An error occurred. Please try again later.', { classname: 'bg-danger text-light', delay: 7500, autohide: true });
      console.log(error);
    })    
    

  }

  ngOnInit() {

    this.EnquiryData_BsaForm$ = this.formBuilder.group({
      id: [0, Validators.required],
      bsaNameSurname: ['', Validators.required],
      bsacontactNumber: ['', Validators.required],
      bsaemailAddress: ['', [Validators.required, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,9}$")]],
      bsacompanyName: ['', Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(350)])],
      bsaofficeNumber: ['', Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(350)])],
      bsawebsite: [''],
      bsamessage: ['', Validators.required],
      bsalinkedin: [''],
      bsatwitter: [''],
      bsafacebook: [''],
      bsainstagram: [''],
      bsayoutube: [''],
      topicId: [''],
      topic: [''],
      recaptchaReactive: null
    });
    
  }
  socialmedialinks: any = [
    { id: "bsalinkedin", name: 'LinkedIn',displayer:'ShowLinkedIn' },
    { id: "bsatwitter", name: 'Twitter',displayer:'ShowTwitter'  },
    { id: "bsafacebook", name: 'Facebook',displayer:'ShowFacebook'  },
    { id: "bsainstagram", name: 'Instagram',displayer:'ShowInstagram'  },
    { id: "bsayoutube", name: 'Youtube',displayer:'ShowYoutube'  }
  ];

 
  
  checked(value){
    const eleLinkedIn = document.getElementById("IsLinkedIn") as HTMLInputElement;
    const eleTwitter = document.getElementById("IsTwitter") as HTMLInputElement;
    const eleInstagram = document.getElementById("IsInstagram") as HTMLInputElement;
    const eleFacebook = document.getElementById("IsFacebook") as HTMLInputElement;
    const eleYoutube = document.getElementById("IsYoutube") as HTMLInputElement;
   // const bsalinkedinControl = this.EnquiryData_BsaForm$.get('bsalinkedin');
   // const bsatwitterControl = this.EnquiryData_BsaForm$.get('bsalinkedin');
   // const bsainstagramControl = this.EnquiryData_BsaForm$.get('bsalinkedin');
   // const bsafacebookControl = this.EnquiryData_BsaForm$.get('bsalinkedin');
   // const bsayoutubeControl = this.EnquiryData_BsaForm$.get('bsalinkedin');

    
    this.EnquiryData_BsaForm$.get('bsalinkedin').setValidators([Validators.nullValidator]);
    this.EnquiryData_BsaForm$.get('bsatwitter').setValidators([Validators.nullValidator]);
    this.EnquiryData_BsaForm$.get('bsainstagram').setValidators([Validators.nullValidator]);
    this.EnquiryData_BsaForm$.get('bsafacebook').setValidators([Validators.nullValidator]);
    this.EnquiryData_BsaForm$.get('bsayoutube').setValidators([Validators.nullValidator]);

    if(eleLinkedIn.checked==true){ 
      this.ShowLinkedIn= true;
      this.EnquiryData_BsaForm$.get('bsalinkedin').setValidators([Validators.required]); 
    }
    else if(eleLinkedIn.checked==false)
    {
      this.ShowLinkedIn= false;
    }

    if(eleTwitter.checked==true){ 
      this.ShowTwitter= true;
      this.EnquiryData_BsaForm$.get('bsatwitter').setValidators([Validators.required]); 
    }
    else if(eleTwitter.checked==false)
    { 
      this.ShowTwitter= false;
    }

    if(eleInstagram.checked==true){ 
      this.ShowInstagram= true;
      this.EnquiryData_BsaForm$.get('bsainstagram').setValidators([Validators.required]); 
    }
    else if(eleInstagram.checked==false)
    {
      this.ShowInstagram= false;
    }
    
    if(eleFacebook.checked==true){ 
      this.ShowFacebook= true;
      this.EnquiryData_BsaForm$.get('bsafacebook').setValidators([Validators.required]); 
    }
    else if(eleFacebook.checked==false)
    {
      this.ShowFacebook= false;
    }

    if(eleYoutube.checked==true){ 
      this.ShowYoutube= true; 
      this.EnquiryData_BsaForm$.get('bsayoutube').setValidators([Validators.required]); 
    }
    else if(eleYoutube.checked==false)
    { 
      this.ShowYoutube= false;
    }
    this.EnquiryData_BsaForm$.get('bsalinkedin').updateValueAndValidity();
    this.EnquiryData_BsaForm$.get('bsainstagram').updateValueAndValidity();
    this.EnquiryData_BsaForm$.get('bsatwitter').updateValueAndValidity();
    this.EnquiryData_BsaForm$.get('bsafacebook').updateValueAndValidity();
    this.EnquiryData_BsaForm$.get('bsayoutube').updateValueAndValidity();


  }


}
